export const HOURS_IN_DAY = 24
export const DAYS_OF_WEEK = 7
export const MONTH_NUMBER_FORMAT = 'MM'
export const MONTH_STRING_SHORT_FORMAT = 'MMM'

export const DATE_FORMAT_SHORT = 'DD/MM'                    // 13/09
export const DATE_FORMAT = 'L'                              // 13/09/2018
export const DATETIME_FORMAT = 'L LTS'                      // 13/09/2018 08:30:00
export const DATETIME_FORMAT_SHORT = 'L LT'                 // 13/09/2018 8:30
export const ISO_DATE_FORMAT = 'YYYY-MM-DD'                 // 2018-09-13
export const ISO_DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss[Z]' // 2018-09-13T08:30:00Z
export const ISO_DATETIME_FORMAT_MILISECONDS = 'YYYY-MM-DDTHH:mm:ss.sss[Z]' // 2018-09-13T08:30:00.000Z
export const EUROPEAN_DATE_FORMAT = 'DD-MM-YYYY'            // 20/02/2020
export const NATURAL_DATE_FORMAT_SHORT = 'll'               // 13 Sep 2018
export const NATURAL_SHORT_WITH_HOUR = 'D MMM LT'           // 13 Sep 9:17
export const NATURAL_DATE_SHORT_WITH_HOUR = 'D MMM YYYY | LT'      // 13 Sep 2018 | 9:17
export const NATURAL_DATETIME_FORMAT = 'LL LTS'             // 13 September 2018 08:30:00
export const UNAWARE_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss' // 2018-09-13 08:30:00
export const NATURAL_NAME_DATETIME_FORMAT = 'dddd, D MMMM YYYY' // Wednesday, 13 September 2018
export const NATURAL_SHORT_NAME_DATETIME_FORMAT = 'dddd, D MMM.' // Wednesday, 13 Sep.
export const HOUR_DATETIME_FORMAT = 'LT'                    // 08:30

export const EMPTY_DATE = '--/--/----'
